import { render, staticRenderFns } from "./childBuyBrand.vue?vue&type=template&id=aa802f40&scoped=true"
import script from "./childBuyBrand.vue?vue&type=script&lang=js"
export * from "./childBuyBrand.vue?vue&type=script&lang=js"
import style0 from "./childBuyBrand.vue?vue&type=style&index=0&id=aa802f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa802f40",
  null
  
)

export default component.exports